import {
  ComponentDetailsByFileOut,
  InventoryProductDetailsByFileOut,
  InternalProductSearchOutput,
} from "api-client";
import { useTranslation } from "react-i18next";
import { useLocation, useNavigate } from "react-router";
import { searchStore } from "features/ProductSearch/SearchStore";
import {
  ORGANIZATIONAL_SEARCH_TABS_LIST,
  SEARCH_TABS_LIST,
} from "../MappingEditor/consts";
import { CustomProduct } from "features/BuildingProductEditor/ProductEditorStore";
import { COEStore } from "features/ComponentEditor/ComponentEditorStore";
import { ROUTES_ENUM } from "routes/consts";

export const useMappingTools = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const location = useLocation();

  const productAdditionalInfo = (
    product:
      | InternalProductSearchOutput
      | InventoryProductDetailsByFileOut
      | undefined
      | CustomProduct,
    tags?: boolean,
    isComponent?: boolean
  ) => [
    {
      label: `DIN276 ${t("mapping.category")}`,
      value: (product as InternalProductSearchOutput)?.din_category
        ? `${
            (product as InternalProductSearchOutput)?.din_category_number ?? ""
          } ${(product as InternalProductSearchOutput)?.din_category ?? "-"}`
        : `${
            (product as InventoryProductDetailsByFileOut)
              ?.din_category_level_1_number ?? ""
          } ${
            (product as InventoryProductDetailsByFileOut)
              ?.din_category_level_1 ?? "-"
          }`,
    },
    ...(isComponent
      ? []
      : [
          {
            label: t("mapping.lifeSpan"),
            value: product?.life_span ?? "-",
          },
        ]),
    ...(tags
      ? [
          {
            label: t("mapping.tags_automapper"),
            value:
              (product as InventoryProductDetailsByFileOut)?.automapping_tags
                ?.map((item) => item)
                .join(", ") || "-",
          },
        ]
      : []),
  ];

  const productCircularityInfo = (
    product: ComponentDetailsByFileOut | undefined
  ) => [
    {
      label: t("productEditor.material_origin"),
      value: product?.preuse_qualification,
      score: product?.preuse_score,
    },
    {
      label: t("productEditor.deconstructability"),
      value: product?.deconstructability_qualification,
      score: product?.deconstructability_score,
    },
    {
      label: t("productEditor.separability"),
      value: product?.separability_qualification,
      score: product?.separability_score,
    },
    {
      label: t("mapping.reusePotential"),
      value: product?.reusability_qualification,
      score: product?.reusability_score,
    },
  ];

  const tabList = searchStore.usingOrganisationSearch
    ? ORGANIZATIONAL_SEARCH_TABS_LIST
    : SEARCH_TABS_LIST;

  const handleGoUp = () => {
    const currentPath = location.pathname;
    const newPath =
      currentPath.substring(0, currentPath.lastIndexOf("/")) || "/";
    if (COEStore.openedSearchInCE) {
      navigate(`${newPath}/${ROUTES_ENUM.COMPONENT_EDITOR}`);
    } else {
      navigate(newPath);
    }
  };

  function onCloseEditor(
    tabIndex?: number,
    shouldCloseSearch?: boolean,
    isDetails?: boolean
  ) {
    handleGoUp();
    if (shouldCloseSearch) {
      searchStore.setOpenProductSearch({ state: false });
      COEStore.setOpenedSearchInCE(false);
    } else if (!isDetails && tabIndex !== undefined) {
      searchStore.setSelectedTab(tabList[tabIndex]);
      searchStore.setOpenProductSearch({ state: true });
    }
  }

  return {
    productAdditionalInfo,
    onCloseEditor,
    productCircularityInfo,
  };
};
